import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {SERVER_API_PREFIX} from "@/app.constants";

@Injectable({
    providedIn: "root",
})
export class HistoryOrderService {
    constructor(private http: HttpClient) {
    }

    query(params: any): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/list`, {
            params,
        });
    }

    orderDetail(orderId: String): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/detail/${orderId}`);
    }

    export(params: any): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/export`, {params});
    }

    exportOrderGoods(params: any): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/export/orderGoods`, {params});
    }

    dynamicQuery(params: any): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/hibianli/list`, {
            params,
        });
    }

    dynamicOrderDetail(orderId: String): Observable<any> {
        return this.http.get(`${SERVER_API_PREFIX}/historyOrder/hibianli/detail/${orderId}`);
    }
}
